import React, { CSSProperties } from 'react';
import { Entry } from 'contentful';
import { Row, Col, Icon } from 'antd';
import ShadowBox from 'layouts/ShadowBox';
import { InfoBoxSection } from 'types/Content';
import css from './InfoBoxBlock.module.scss';

interface InfoBoxProps {
  section: Entry<InfoBoxSection>;
}

const sBoxStyle: CSSProperties = {
  flexBasis: 'auto',
  minHeight: '7em',
  padding: '0.5em'
};

export default function InfoBoxBlock({ section }: InfoBoxProps) {
  const {
    title,
    description,
    icon,
    iconColour,
    backgroundColour,
    infoBoxBackgroundColour
  } = section.fields;

  const infoBgColour = infoBoxBackgroundColour
    ? { backgroundColor: infoBoxBackgroundColour }
    : undefined;

  return (
    <Row
      type="flex"
      justify="center"
      style={
        backgroundColour ? { backgroundColor: backgroundColour } : undefined
      }
    >
      <Col lg={18} xs={22}>
        <div className={css.features}>
          <ShadowBox
            style={{...sBoxStyle, ...infoBgColour}}
          >
            <div
              className={css.feature}
              style={infoBgColour}
            >
              <div className={css.featureIcon}>
                <Icon
                  type={icon}
                  style={{ color: iconColour, fontSize: '2em' }}
                />
              </div>
              <div className={css.featureText}>
                <b>{title} - </b>
                {description}
              </div>
            </div>
          </ShadowBox>
        </div>
      </Col>
    </Row>
  );
}
